<script setup>
const route = useRoute();
const nuxtApp = useNuxtApp();
const props = defineProps({
  parentSeoImage: [Object, null],
});

const { getPage } = useWpApi();
const { data, error } = await getPage(route.path, nuxtApp);

if (error.value
  || (!isNaN(data.value?.length) && !data.value.length)
  || data.value?.notFound === true
) {
  throw createError({ statusCode: 404, statusMessage: "Page Not Found" });
}

const hasOwnOgOverwrite = computed(
  () => !!data.value?.yoast_head_json?.og_image
);
const schemaImage = computed(() =>
  !hasOwnOgOverwrite.value && props.parentSeoImage
    ? props.parentSeoImage.url
    : data.value?.yoast_head_json?.og_image.url
);

watch(
  () => data.value,
  (newVal) => {
    nextTick(() => {
      useWpSeo(data, schemaImage.value);
    });
  },
  { immediate: true }
);

if (!hasOwnOgOverwrite.value && props.parentSeoImage) {
  const image = props.parentSeoImage;
  useHead({
    meta: [
      { hid: "og:image", property: "og:image", content: image.url },
      { hid: "og:image-type", property: "og:image-type", content: image.type },
      {
        hid: "og:image-width",
        property: "og:image-width",
        content: image.width,
      },
      {
        hid: "og:image-height",
        property: "og:image-height",
        content: image.height,
      },
    ],
  });
}

const searchMode = ref(false);
const searchInput = ref(null);
const searchTerm = ref(null); // v-model

const isReportsPage = computed(() => route.fullPath === "/investors/reports/");

const searchResults = computed(() => {
  const dataFound = [];

  data.value?.acf.page_modules.map((module) => {
    if (module.acf_fc_layout === "reports") {
      module.items.map((item) => {
        if (item.acf_fc_layout === "press_release") {
          if (
            item.item[0]?.title
              ?.toLowerCase()
              .indexOf(searchTerm.value?.toLowerCase() ?? "") > -1 ||
            item.item[0]?.rich_text
              ?.toLowerCase()
              .indexOf(searchTerm.value?.toLowerCase() ?? "") > -1
          ) {
            dataFound.push(item);
          }
        }
        if (item.acf_fc_layout === "download") {
          if (
            (item.item[0]?.title &&
              item.item[0]?.title
                ?.toLowerCase()
                .indexOf(searchTerm.value?.toLowerCase() ?? "") > -1) ||
            item.item[0]?.label
              ?.toLowerCase()
              .indexOf(searchTerm.value?.toLowerCase() ?? "") > -1 ||
            item.item[0]?.file.filename
              ?.toLowerCase()
              .indexOf(searchTerm.value?.toLowerCase() ?? "") > -1
          ) {
            item.highlight = false;
            dataFound.push(item);
          }
        }
      });
    }
  });

  return dataFound;
});

watch(searchTerm, () => {
  if (searchTerm.value.length > 0) {
    searchMode.value = true;
  } else {
    searchMode.value = false;
  }
});

const updateInputChange = (value) => {
  searchTerm.value = value;
  // console.log("updateInputChange", searchTerm.value.value, search.value);
};
const updatePerformSearch = (value) => {
  searchTerm.value = value;
};
const isVisible = ref(false);

function runIntroAnimation(e) {
  e.state.isActive ? (isVisible.value = true) : null;
}
</script>

<template>
  <div
    class="page investors-slug-file"
    :class="{ '-reports-page': isReportsPage, 'can-run': isVisible }"
    v-view="(e) => runIntroAnimation(e)"
  >
    <div class="page-inner" v-if="data">
      <div v-if="isReportsPage">
        <ElementsSearch
          class="search reveal"
          @perform-search="updatePerformSearch"
          @input-change="updateInputChange"
        />
      </div>
      <transition name="fade">
        <div class="reports-search" v-if="searchMode">
          <Intro headline="Reports search" />
          <Reports
            :hasHeading="false"
            :items="searchResults"
            :reveal-progress="0"
          />
        </div>
      </transition>

      <PageModules
        v-if="data?.acf && !searchMode"
        :modules="data.acf.page_modules"
      />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.page {
  --translate-title: units(1.5);
  --opacity-title: 0;

  &.can-run {
    --translate-title: 0;
    --opacity-title: 1;
  }
}

.-reports-page {
  :deep(.section.reports h2) {
    @media (--until-md) {
      margin-bottom: 80px;
    }
  }
}

.page-inner {
  position: relative;
  z-index: 0;
  /* padding-top: units(9); */

  &:deep(.reports) {
    padding-top: units(2);
    @media (--md) {
      padding-top: 0;
    }
  }

  @media (--md) {
    padding-top: 0;
  }
}

/* .search {
  position: absolute;
  top: 0;
  z-index: 1;
  width: calc(100% - var(--page-margin) * 2);
  @media (--until-md) {
    top: 145px;
    left: var(--page-margin);
  }
  @media (--md) {
    top: 85px;
    right: var(--page-margin);
    text-align: right;
  }
} */

.search {
  position: absolute;
  top: 0;
  z-index: 1;
  width: calc(100% - var(--page-margin) * 2);

  @media (--until-md) {
    margin-top: units(3);
    left: 50%;
    transform: translateX(-50%);
  }

  @media (--md) {
    top: 85px;
    right: var(--page-margin);
    text-align: right;
  }

  /* padding-right: units(2); */
}
</style>
